module.exports = __webpack_public_path__ + "static/media/arrow-down.0bdc215c.svg";